import { useQuery } from '@tanstack/react-query';
import { api } from '@/api';
import { queryKeys } from '@/api/query-keys';
import type { Me } from '@/types/api';

// Single source of truth for "who is the current user". Returns undefined
// while loading, null when not authenticated, or the Me object (which is
// User + personal_context).
export function useMe() {
  return useQuery<Me | null>({
    queryKey: queryKeys.auth.me,
    queryFn: async () => {
      try {
        return await api.auth.me();
      } catch {
        return null;
      }
    },
    staleTime: 1000 * 60 * 5,
    retry: false,
  });
}
